export default __webpack_public_path__ + "static/media/category_05.d8aee336.png";